import { createContext, useContext, useState, useCallback, ReactNode } from "react";
import { PaywallModal } from "@/components/PaywallModal";

type PaywallContextValue = {
  open: (featureLabel?: string) => void;
  close: () => void;
};

const PaywallContext = createContext<PaywallContextValue | null>(null);

export function PaywallProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [featureLabel, setFeatureLabel] = useState<string | undefined>(undefined);

  const open = useCallback((label?: string) => {
    setFeatureLabel(label);
    setIsOpen(true);
  }, []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <PaywallContext.Provider value={{ open, close }}>
      {children}
      <PaywallModal open={isOpen} onClose={close} featureLabel={featureLabel} />
    </PaywallContext.Provider>
  );
}

export function usePaywall(): PaywallContextValue {
  const ctx = useContext(PaywallContext);
  if (!ctx) {
    // Fallback no-op (e.g. tests without provider) so guards never crash.
    return { open: () => {}, close: () => {} };
  }
  return ctx;
}
